<template>
  <div class="page-box">
    <Header />
    <PartnerContent />
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import PartnerContent from './PartnerContent.vue'
import metaInfo from '@/common/util/metaInfo'

export default {
  name: "CoPlan",
  metaInfo: metaInfo.coPlan,
  components: {
    Header,
    Footer,
    PartnerContent
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped></style>
